import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchUpgradePlanInvoice,
  upgradePlan,
  applyCoupon,
  removeCoupon,
} from "../../redux/actions/checkoutAction";
import { loader, crossIcon } from "../../constants/Images";
import {
  formatDate,
  formatDateFromTimeStamp,
} from "../../helpers/genericHelpers";
import Blinking from "../../Loaders/Blinking";
import { Redirect } from "react-router-dom";
import { toast } from "react-toastify";

export default function SwitchPlan() {

  const [showApplyCouponForm, setShowApplyCouponForm] = useState(false);
  const [couponValue, setCouponValue] = useState("");


  const {
    isFetchUpgradePlanInvoiceStarted,
    isFetchUpgradePlanInvoiceFetched,
    isUpgradePlanStarted,
    isUpgradePlanDone,
    upgradedPlanInvoice,
    isApplyCouponStarted, 
    isCouponApplied, 
    couponDetails
  } = useSelector((state) => state.checkoutData);

  const {total_discounted_amount, total_discounted_amount_formatted, coupon} = couponDetails || {};

  const { lines, currency } = upgradedPlanInvoice || {};
  const { data } = lines || {};
  const [selectedPlanDetails, setSelectedPlanDetails] = useState({});
  const dispatch = useDispatch();
  const getParams = () => {
    const queryString = window.location.search;
    let str = queryString.substring(1);
    let queryarr = str.split("&&");
    let obj = {};
    for (let i = 0; i < queryarr.length; i++) {
      let str = queryarr[i];
      let strS = str.split("=");
      obj[strS[0]] = decodeURI(strS[1]);
    }
    setSelectedPlanDetails(obj);
  };

  const handleGoBack = () => {
    window.history.back();
  };

  const handleUpgradePlan = () => {
    let data = {
      stripe_subscription_id: selectedPlanDetails.method,
      plan_id: selectedPlanDetails.plan,
      plan_description: `${selectedPlanDetails.name} ${selectedPlanDetails.subscription}`
    };
    if (isCouponApplied) {
      data.coupon = coupon;
    }
    dispatch(upgradePlan(data));
  };

  const handleShowApplyCouponForm = () =>
  setShowApplyCouponForm(!showApplyCouponForm);
  const handleCounponChange = (e) => {
    e.persist()
    setCouponValue(e.target.value)
  }
  const handleApplyCoupon = () => {
      if(couponValue === "") {
        toast.warn('Please enter the coupon code')
        return;
      }
      let couponObj = {
      coupon: couponValue,
      plan_id: selectedPlanDetails.plan,
      }
      dispatch(applyCoupon(couponObj))
  }
  const handleRemoveCoupon = () => {
      dispatch(removeCoupon())
  }
  useEffect(() => {
    if(isCouponApplied) {
      setCouponValue("")
      setShowApplyCouponForm(false)
    }
  }, [isCouponApplied]);

  useEffect(() => {
    getParams();
  }, []);

  useEffect(() => {
    let data = {
      stripe_subscription_id: selectedPlanDetails.method,
      plan_id: selectedPlanDetails.plan,
    };
    if (selectedPlanDetails.method) {
      dispatch(fetchUpgradePlanInvoice(data));
    }
  }, [selectedPlanDetails]);
  return (
    <>
      {isUpgradePlanDone && <Redirect to="/customers" />}
      <div className="adminCard">
        <div className="table-responsive userlist-table">
          {isFetchUpgradePlanInvoiceStarted && (
            <div className="text-center p-5">
              <img src={loader} alt="loader" style={{ width: "80px" }} />
            </div>
          )}
          {isFetchUpgradePlanInvoiceFetched && (
            <table className="table">
              <thead className="text-uppercase">
                <tr style={{ height: "57px" }}>
                  <th
                    scope="col"
                    className="rw-pl-50"
                    style={{ width: "800px" }}
                  >
                    Description
                  </th>
                  <th
                    scope="col"
                    style={{ width: "250px", textAlign: "right" }}
                  >
                    Duration
                  </th>
                  <th scope="col" className="text-right">
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                {data &&
                  data.map((line) => {
                    return (
                      <tr key={line.id}>
                        <td className="rw-pl-50">
                          <span>{line.description}</span>
                        </td>
                        <td className="text-right">
                          <span>{`${formatDateFromTimeStamp(
                            line.period.start
                          )} ${formatDateFromTimeStamp(
                            line.period.end
                          )}`}</span>
                        </td>
                        <td className="text-right">
                          <span className="text-uppercase">{`${line.currency} ${
                            line.amount / 100
                          }`}</span>
                        </td>
                      </tr>
                    );
                  })}

                <tr style={{ fontWeight: "bold" }}>
                  <td className="rw-pl-50"></td>
                  <td className="text-right">
                    <span>Sub Total</span>
                  </td>
                  <td className="text-right text-uppercase">
                    <span>{`${currency} ${upgradedPlanInvoice.subtotal / 100}`}</span>
                  </td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td className="rw-pl-50"></td>
                  <td className="text-right" colSpan="2">
                  <div className="clearfix profileArea">
                      <form
                        action=""
                        className="form invitePeopleForm"
                        style={{ maxWidth: "300px", float: "right" }}
                      >
                        <div className="row gutters-5">
                          {showApplyCouponForm ? (
                            <>
                              <div className="col hide-col mt-2">
                                <div className="form-group mt-0">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Coupon Code"
                                    defaultValue={couponValue}
                                    onChange={handleCounponChange}
                                  />
                                </div>
                              </div>
                              <div className="mt-2">
                                <div className="form-group mt-0">
                                  <button
                                    type="button"
                                    className="submit-btn rs_secondary_bg  text-uppercase"
                                    onClick={handleApplyCoupon}
                                  >
                                    Apply {isApplyCouponStarted && <Blinking fontSize={20} />}
                                  </button>
                                  <span
                                    className="invitePeopleHide ml-3 c-pointer"
                                    onClick={handleShowApplyCouponForm}
                                  >
                                    <img src={crossIcon} alt="" />
                                  </span>
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="col-12">
                              {
                                isCouponApplied ? <>
                                <span className="font-weight-normal">Coupon applied <b>{coupon}</b></span> <span
                                    className="invitePeopleHide ml-3 c-pointer"
                                    onClick={handleRemoveCoupon}
                                  >
                                    <img src={crossIcon} alt="" />
                                  </span>
                                </> : <>
                                <span>Have a Coupon Code?</span>
                              <button
                                type="button"
                                className="rs_btn rs_md_btn rs_secondary_color_btn text-uppercase"
                                onClick={handleShowApplyCouponForm}
                              >
                                Apply
                              </button></>
                              }
                            </div>
                          )}
                        </div>
                      </form>
                    </div>
                  </td>
                  
                </tr>
                <tr className={"font-weight-bold " + (isCouponApplied ? "lineThroughText": null)}>
                  <td className="rw-pl-50"></td>
                  <td className="text-right">
                    <span>Total</span>
                  </td>
                  <td className="text-right text-uppercase">
                    <span>{`${currency} ${upgradedPlanInvoice.total / 100}`}</span>
                  </td>
                </tr>
                {isCouponApplied && <tr className={"font-weight-bold"}>
                  <td className="rw-pl-50"></td>
                  <td className="text-right">
                    <span>Total</span>
                  </td>
                  <td className="text-right">
                    <span>{`${total_discounted_amount_formatted}`}</span>
                  </td>
                </tr>}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan="3" className="text-right">
                    {
                      isUpgradePlanStarted ? <button
                      className="rs_sm_btn rs_btn rs_primary_bg text-uppercase mr-2 deadLink"
                    > Updating Plan <Blinking fontSize={20} />{" "}
                    </button> : <button
                      className="rs_sm_btn rs_btn rs_primary_bg text-uppercase mr-2"
                      onClick={handleUpgradePlan}
                    > Confirm
                    </button>
                    }
                   
                    <button
                      className="rs_sm_btn rs_btn text-uppercase"
                      onClick={handleGoBack}
                    >
                      Cancel
                    </button>
                  </td>
                </tr>
              </tfoot>
            </table>
          )}
        </div>
      </div>
    </>
  );
}
